
const url = process.env.BACKEND_API_URL + '/live';

export const getLiveGame = async () => await fetch(url, { next: { revalidate: 60 } }).then(res => res.json()).catch(err => {
  return null
});

